module.exports = __webpack_public_path__ + "static/img/40010 (1).b3f3802.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40010 (1).webp
// module id = hTGS
// module chunks = 14